import type {
  CardBrand,
  EWalletBrand,
  PaymentMethodBrand,
  PaymentMethodCategory
} from '../../../../types/registration-payment.types';

export interface PaymentMethodConfig {
  label: string;
  /** Absolute public URL path for the logo image */
  logo: string;
  /** Whether the Important Notes dialog should be shown before redirecting to gateway */
  requiresImportantNotes: boolean;
  category: PaymentMethodCategory;
}

const PUBLIC = process.env.PUBLIC_URL || '';

export const PAYMENT_METHOD_CONFIG: Record<
  PaymentMethodBrand,
  PaymentMethodConfig
> = {
  visa: {
    label: 'Visa',
    logo: `${PUBLIC}/assets/logos/Visa_Logo_2.png`,
    requiresImportantNotes: true,
    category: 'cards'
  },
  mastercard: {
    label: 'Mastercard',
    logo: `${PUBLIC}/assets/logos/MASTERCARD-logo.png`,
    requiresImportantNotes: true,
    category: 'cards'
  },
  amex: {
    label: 'AMEX',
    logo: `${PUBLIC}/assets/logos/american_express.png`,
    requiresImportantNotes: true,
    category: 'cards'
  },
  unionpay: {
    label: 'UnionPay',
    logo: `${PUBLIC}/assets/logos/union_pay.svg`,
    requiresImportantNotes: true,
    category: 'cards'
  },
  grabpay: {
    label: 'GrabPay',
    logo: `${PUBLIC}/assets/logos/grab-pay.jpeg`,
    requiresImportantNotes: false,
    category: 'ewallets'
  },
  tng: {
    label: "Touch 'n Go eWallet",
    logo: `${PUBLIC}/assets/logos/TNG-EWALLET-logo.png`,
    requiresImportantNotes: false,
    category: 'ewallets'
  },
  shopeepay: {
    label: 'ShopeePay',
    logo: `${PUBLIC}/assets/logos/shopeepay2.svg`,
    requiresImportantNotes: false,
    category: 'ewallets'
  }
};

export const CARD_BRANDS: CardBrand[] = [
  'visa',
  'mastercard',
  'amex',
  'unionpay'
];

export const EWALLET_BRANDS: EWalletBrand[] = ['grabpay', 'tng', 'shopeepay'];

/** Maps resolved payment gateway name to whether Important Notes (RM 1.00 notice) should be shown. */
export const GATEWAY_REQUIRES_IMPORTANT_NOTES: Record<string, boolean> = {
  fiuu: true,
  stripe: false
};
